import { useEffect, useState } from "react";
import { getExplorations } from "@/lib/apiClient";
import AdminNav from "@/components/AdminNav";

const stateStyle = {
  STRONG: "bg-brlime text-ink", SOME: "bg-bryellow text-ink",
  LIMITED: "bg-secondary text-ink/70", INSUFFICIENT: "bg-brorange text-white",
};

export default function AdminExplorations() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { getExplorations().then((d) => { setRows(d); setLoading(false); }); }, []);

  return (
    <div>
      <AdminNav />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <p className="eyebrow text-ink/60">Diagnostic</p>
        <h1 className="font-display font-extrabold text-4xl display-tight uppercase">Market Explorations</h1>
        <p className="text-sm text-ink/60 mt-1">Every live Explore Opportunity search run by visitors — real searches, pages reviewed, results and outcome.</p>

        <div className="mt-6 border-2 border-ink overflow-x-auto">
          <table className="w-full text-sm min-w-[820px]" data-testid="explorations-table">
            <thead><tr className="bg-ink text-white text-left">
              <th className="px-3 py-3">Case</th><th className="px-3 py-3">Concept</th><th className="px-3 py-3">Country</th>
              <th className="px-3 py-3">Date</th><th className="px-3 py-3">Searches</th><th className="px-3 py-3">Pages</th>
              <th className="px-3 py-3">Results</th><th className="px-3 py-3">State</th><th className="px-3 py-3">Credits</th>
            </tr></thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={9} className="px-3 py-10 text-center text-ink/40">Loading…</td></tr>
              ) : rows.length === 0 ? (
                <tr><td colSpan={9} className="px-3 py-10 text-center text-ink/40">No explorations yet.</td></tr>
              ) : rows.map((r) => (
                <tr key={r.id} className="border-t border-ink/10 align-top">
                  <td className="px-3 py-2.5 max-w-[180px] truncate">{r.case_company || r.case_headline}</td>
                  <td className="px-3 py-2.5 max-w-[240px] truncate text-ink/60">{r.concept}</td>
                  <td className="px-3 py-2.5 whitespace-nowrap">{r.country}</td>
                  <td className="px-3 py-2.5 text-ink/50 whitespace-nowrap">{r.search_date ? new Date(r.search_date).toLocaleDateString() : (r.status === "running" ? "running…" : "—")}</td>
                  <td className="px-3 py-2.5">{r.searches_performed}</td>
                  <td className="px-3 py-2.5">{r.pages_reviewed}</td>
                  <td className="px-3 py-2.5 font-semibold">{r.relevant_found}</td>
                  <td className="px-3 py-2.5">{r.result_state ? <span className={`eyebrow px-2 py-0.5 ${stateStyle[r.result_state] || ""}`}>{r.result_state}</span> : <span className="text-ink/40">{r.status}</span>}</td>
                  <td className="px-3 py-2.5 text-ink/50">{r.credits_estimate ?? "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
